/* global angular */

var ngModule = angular.module('trends');

var DEFAULT_PAGE_SIZE = 6;
var TREND_PDF_ENABLED = true;

ngModule.directive('contentList', ['$stateParams', '$parse', 'AjaxList', 'Api', '$sce', 'HistoricContext',
    function ($stateParams, $parse, AjaxList, Api, $sce, HistoricContext) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                /* Request that the list change its data source (filters). Does nothing if
                   the filters haven't changed. */
                scope.updateFilters = function () {
                    if (!angular.equals(scope.filters.active, scope.filters.selected)) {
                        scope.content.reset();
                        scope.filters.active = angular.copy(scope.filters.selected);
                        scope.storeFilters();

                        var promise = scope.loadMore();
                        if (promise) {
                            promise.then(function () { scope.$broadcast('dataSourceChanged'); });
                        }
                    }
                };

                /* Reset the filters to null, which displays the HVT name for each,
                   and retrieve the unfiltered observations again. */
                scope.resetFilters = function() {
                    for (var x in scope.filters.selected) {
                        if (!scope.filters.params[x + '_fixed']) {
                            scope.filters.selected[x] = null;
                        }
                    }

                    scope.updateFilters();
                };

                /* Store the filter name and type into the HistoricContext */
                scope.storeFilters = function() {
                    var filter = {};
                    var filterName = [];
                    var filterType = [];
                    var filterEnable = false;

                    // get selection values by pairing pk values
                    Object.keys(scope.filters.selected).forEach(function(key) {
                        var value = key.charAt(0).toUpperCase() + key.substring(1, key.length);
                        if (scope.filters.active[key] !== null) {
                            filterEnable = true;
                            var pkValue = scope.filters.active[key];
                            for (var i = 0; i < scope.filters.sources[key].items.length; i++) {
                                if (scope.filters.sources[key].items[i].pk === pkValue) {
                                    filter[value] = scope.filters.sources[key].items[i].description;
                                    break;
                                }
                            }
                        }
                    });

                    // store the filter name
                    Object.keys(filter).forEach(function(key) {
                        var value = key + ': ' + filter[key];
                        filterName.push(value);
                    });

                    filterType = Object.keys(filter);
                    HistoricContext.insert('search_filter_type_context', filterType, 'session');
                    HistoricContext.insert('search_filter_name_context', filterName, 'session');
                    HistoricContext.save();
                };

                /* The Trend PDF is a yearly static item for trend
                   tab , more details on MOAT-28931, this static item
                   only shows on trend tab at first position, and will
                   be hidden when there are filters or in the observasion
                   tab or in the single trend/observation item page.
                */
                scope.show_trendpdf = function (filter) {
                    /* when in single trend/observation page, the filter is undefined */
                    if (filter === undefined) {
                        return false;
                    }
                    return true;
                };

                /* Try to load another page of content. Does nothing if there's no data left. */
                scope.loadMore = function () {
                    var filters = scope.filters ? scope.filters.active : null;
                    /* use selectedTab to only enable trendpdf on the trend homepage */
                    if (TREND_PDF_ENABLED && scope.selectedTab === 'trend' && scope.show_trendpdf(scope.filters)){
                        var trend_pdf = 'trendpdf';
                        scope.content.another_resource = Api.content[trend_pdf];
                    }
                    else{
                        // reset static trendpdf to null when there are filters or
                        // not in 'trend' Tab
                        scope.content.another_resource = null;
                    }
                    var promise = scope.content.loadNext(filters);

                    if (promise) {
                        if (filters) {
                            lastFilters = angular.copy(scope.filters.active);

                            /* emit after a page of data has been loaded */
                            promise.then(function () {
                                scope.$emit('contentListLoad', category);
                            });
                        }
                    }
                    else {
                        if (scope.content.isFullyLoaded()){
                            scope.$emit('contentListLoaded', category);
                        }
                    }
                    return promise;
                };

                /* Return a string as being html trusted. */
                scope.getHtmlSafeString = function (str) {
                    return $sce.trustAsHtml(str);
                };

                scope.isEmptyResult = function () {
                    return scope.content.isEmptyResult();
                };

                var lastFilters = null;
                var category = attrs.category;
                scope.tab_category = category;
                var lazy = $parse(attrs.lazy)(scope);
                var pageSize = parseInt(attrs.pageSize, 10) || DEFAULT_PAGE_SIZE;

                scope.stateParams = $stateParams;

                // Setup the underlying data source
                var defaultParams = $parse(attrs.contentParams || '{}')(scope);
                // For trend tab, do multiple-field ordering in back-end API
                if (attrs.category !== 'trend' && defaultParams.order_by === undefined) {
                    if (defaultParams.sort_by_rank === undefined || defaultParams.sort_by_rank === false){
                        defaultParams.order_by = '-display_date';
                    }
                }

                scope.content = new AjaxList(Api.content[category], {defaultParams: defaultParams, pageSize: pageSize});

                scope.$on('tabChanged', function (ev, selected) {
                    if (category === selected && !angular.equals(lastFilters, scope.filters.active)) {
                        scope.content.reset();
                        scope.loadMore();
                    }
                });

                if (!lazy) {
                    scope.loadMore();
                }
            }
        };
    }]);
